import { ComboBoxData } from '../types/types';

/* eslint-disable */
export const ProductType = 'RPDAGR';

export enum ProductPermissions {
  AGREEMENT = 'AGREEMENT',
}
export const RACPAD = 'RACPAD';
export const AMOrigin = 'am-customer';
export const AccountManagementURLParam = `?origin=${AMOrigin}`;
// Identifies the promotion rule that controls whether Days Extension stays editable.
export const ALLOW_INTIAL_PAYMENT_EXTENSION_DAYS =
  'ALLOW_INTIAL_PAYMENT_EXTENSION_DAYS';
export const SACrolesArray = [
  "FSC-CAR",
  "CAR",
  "RPMT",
  "FSC-AM",
  "AM",
  "FSC-LAM",
  "LAM",
  "FSC-SMT",
  "SMT",
  "FSC-SM",
  "SM",
  "FSC-SSM",
  "SSM",
  "CAM",
  "FSC-DMT",
  "DMT",
  "FSC-DM",
  "DM",
  "FSC-RDT",
  "RDT",
  "FSC-RD",
  "RD"
];
export const ADD_ON_PACKAGE = 'Add-On Package'
export const ADD_ON_PRICING = 'AddOnPricing'
export const termOverrideLimit = {"min" : 0, "max" : 0}
export const priceOverrideLimit = {"min" : 0, "max" : 0}

// DE Approval Amount enforcement (L4/L5 weekly rate & total cash price limits)
export const DE_ENFORCEMENT_EXCEPTION_REF_CODE = 'DEAOR';
export const DE_ENFORCEMENT_REASON = {
  DISABLED_AT_STORE: 'DISABLED_AT_STORE',
  SWITCHOUT: 'SWITCHOUT',
  REINSTATEMENT: 'REINSTATEMENT',
  AGREEMENT_TYPE_NOT_ENFORCED: 'AGREEMENT_TYPE_NOT_ENFORCED',
  NO_DE: 'NO_DE',
  DE_DECLINED: 'DE_DECLINED',
  LEVEL_NOT_ENFORCED: 'LEVEL_NOT_ENFORCED',
  INVALID_CONFIGURATION: 'INVALID_CONFIGURATION',
  ENFORCEMENT_AMOUNTS_UNAVAILABLE: 'ENFORCEMENT_AMOUNTS_UNAVAILABLE',
  DE_APPROVAL_AMOUNTS_UNAVAILABLE: 'DE_APPROVAL_AMOUNTS_UNAVAILABLE',
  EXCEEDS_MAXIMUM_AUTHORITY: 'EXCEEDS_MAXIMUM_AUTHORITY',
};

export const emptyField : ComboBoxData = {
  value: '',
  label: 'Please Select',
};

export const getPrimaryPhoneNumber = (phoneDetails: any) => {
  console.log('initial execution', phoneDetails)
  const activePhoneNumber: any = []
  const primaryPhoneNumber: any = []
  for (let phoneNumber = 0; phoneNumber < phoneDetails.length; phoneNumber++) {
    if (phoneDetails[phoneNumber]?.primary == 'Y') {
      primaryPhoneNumber.push(phoneDetails[phoneNumber])
      break;
    }
    if (phoneDetails[phoneNumber]?.active == 'Y' && activePhoneNumber.length == 0) {
      activePhoneNumber.push(phoneDetails[phoneNumber])
    }
  }
  console.log('primaryPhoneNumber', primaryPhoneNumber, activePhoneNumber)
  return primaryPhoneNumber.length > 0 ? primaryPhoneNumber : activePhoneNumber
}

export enum DE_APPROVAL_STATUS_TEXT {
  APPROVED = 'Approved',
  CONDITIONAL_APPROVAL = 'Approved',
  DECLINED = 'Declined',
  EXPIRED = 'DE Expired',
  NO_DE = 'No DE',
  YET_TO_START = 'Yet to Start'
}

export enum DE_APPROVAL_STATUS {
  APPROVED = 'A',
  CONDITIONAL_APPROVAL = 'M',
  DECLINED = 'D',
  EXPIRED = 'E',
  YET_TO_START = 'Y'
}

export const enum DOCUMENT_TYPE {
  IDENTITY_DOC = 'IDENTTYDOC',
  EMPLOYMENT_DOC = 'EMPDOC',
  RESIDENCE_DOC = 'RESDOC'
}

export const CARRIED_RENT_ERROR_MESSAGE = 'All carried rent must be collected before any agreements can be split/switched.';

export function getVerificationString(customerApprovalDetails: any) {
  if (!customerApprovalDetails || !customerApprovalDetails.verificationDocuments) {
    return '';
  }

  const requiredVerifications = customerApprovalDetails.verificationDocuments
    .filter((doc: any) => doc.verifyRequired === 'Y' && doc.verifyType !== 'PHONE')
    .map((doc: any) => {
      switch (doc.verifyType) {
        case 'ID':
          return 'Identity';
        case 'RESIDENCE':
          return 'Residence';
        case 'EMPLOYMENT':
          return 'Employment';
        case 'REFERENCES':
          return 'Reference';
        default:
          return '';
      }
    })
    .filter((verif: any) => verif); // Filter out empty strings

  if (requiredVerifications.length === 0) {
    return 'No verification required';
  }

  let verificationString;
  if (requiredVerifications.length === 1) {
    verificationString = requiredVerifications[0];
  } else {
    verificationString = requiredVerifications.slice(0, -1).join(', ') + ', and ' + requiredVerifications.slice(-1);
  }

  return `${verificationString} Verification Required`;
}
export const level4customerSignModuleName = 'LevelFourEmailSignAccess';

// Promotion constants
export const PROMOTION_LOB = 'RAC';
export const PROMOTION_LEASE_TYPE_RTO = 'RTO';
export const PROMOTION_LEASE_TYPE_CO = 'CO';
export const CHANNEL = ['STORE'];

export const customerReferenceValidation = (customerResponse, isMotorcycleAdded, mxReferenceDetails) => {
  const requiredRefs = isMotorcycleAdded ? mxReferenceDetails.Motorcycle : mxReferenceDetails?.Rental;
  const actualRefs = customerResponse?.GetCustomer?.value?.personalReferences?.length || 0;
  return actualRefs >= requiredRefs;
};

const formatByNumeric = (input: string): string => {
  try {
    let onlyNumeric: string = input;
    if (input?.length) {
      return (onlyNumeric).replace(/\D/g, '');
    }
    return onlyNumeric;

  } catch (error: any) {
    console.log("Error in formatByNumeric: ", error?.message);
    return input;
  }
}
export const formatPhoneNumber = (input: string): string => {
  try {
    let phoneNumber: string = input;
    if (input && input.length > 0) {
      const cleaned = formatByNumeric(input); // Ensure this function is defined and works correctly

      // Match and format the phone number
      const match = cleaned.match(
        /^(?:\+?([0-9]{1,3})[-. ]?)?([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
      );

      if (match) {
        const [, cc, area, prefix, line] = match;
        const allowedCodes = ['1', '52', '91'];

        if (!cc || allowedCodes.includes(cc)) {
          phoneNumber = `${cc ? '+' + cc + ' ' : ''}(${area}) ${prefix}-${line}`;
        } else {
          phoneNumber = cleaned; // Return as-is if not allowed
        }
      } else {
        phoneNumber = cleaned; // Fallback if not matched
      }
    }
    return phoneNumber;
  } catch (error: any) {
    console.log("Error in formatPhone: ", error?.message);
    return input;
  }
};